export default __webpack_public_path__ + "static/media/flag-monaco.21487a50.svg";